import { del, get, getBlob, post } from "api";
import {
  RopeLandingPageDataDto,
  RopeLogDto,
  RopeMessageDto,
  RopeImportDto,
  RopeUploadsPageData
} from "../types/Rope";

export function getRopeLandingPageDataDto(): Promise<RopeLandingPageDataDto[]> {
  return get("api/rope/landing_page");
}

export function getRopeUploadMessages(id: number): Promise<RopeMessageDto[]> {
  return get(`api/rope/messages/${id}`);
}

export function getRopeLogEntries(): Promise<RopeLogDto[]> {
  return get(`api/rope/log`);
}

export function getRopeUploadsPageData(
    id: number
): Promise<RopeUploadsPageData> {
  return get(`api/rope/${id}`);
}

export function deleteRopeUpload(id: number) {
  return del(`api/rope/upload/${id}`);
}

export function downloadRope(id: number) {
  return getBlob(`api/rope/download/${id}`);
}

export function uploadRope(file: File, comment: string) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("comment", comment);
  return post(`api/rope/upload`, formData);
}

export function importRope(record: RopeImportDto) {
  return post(`api/rope/import`, record);
}

